import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionButtonComponent } from './action-button.component';
import { BlockUIModule } from 'ng-block-ui';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';

@NgModule({
    declarations: [ActionButtonComponent],
    imports: [
        CommonModule,
        SweetAlert2Module.forRoot(),
        BlockUIModule.forRoot()
    ],
    exports: [ActionButtonComponent]
})
export class ActionButtonModule { }



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/action-button/action-button.module.ts